import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

type SessionCallProntuarioHintBalloonProps = {
	id: string;
	message: string;
	onDismiss: () => void;
	placement: 'above' | 'below';
	align?: 'start' | 'center' | 'end';
	widthClassName?: string;
	className?: string;
};

const ALIGN_CLASS = {
	start: 'left-0',
	center: 'left-1/2 -translate-x-1/2',
	end: 'right-0',
} as const;

const SessionCallProntuarioHintBalloon = ({
	id,
	message,
	onDismiss,
	placement,
	align = 'end',
	widthClassName = 'w-[min(260px,calc(100vw-2rem))]',
	className,
}: SessionCallProntuarioHintBalloonProps) => (
	<div
		id={id}
		role="status"
		className={cn(
			'absolute z-10 rounded-lg border border-white/10 bg-[#1a2430] py-2.5 pl-3 pr-2 text-left text-[12px] leading-snug text-slate-200 shadow-lg',
			widthClassName,
			placement === 'above' && 'bottom-full mb-2',
			placement === 'below' && 'top-full mt-2',
			ALIGN_CLASS[align],
			className,
		)}
	>
		<div className="flex items-start gap-2">
			<p className="min-w-0 flex-1 pt-px">{message}</p>
			<button
				type="button"
				onClick={(event) => {
					event.stopPropagation();
					onDismiss();
				}}
				className="shrink-0 rounded-md p-0.5 text-slate-500 transition-colors hover:bg-white/[0.06] hover:text-slate-300"
				aria-label="Fechar dica"
			>
				<X className="size-3.5" strokeWidth={2.25} />
			</button>
		</div>
		<span
			className={cn(
				'absolute size-2.5 rotate-45 bg-[#1a2430]',
				placement === 'above' &&
					'-bottom-1.5 right-8 border-b border-r border-white/10',
				placement === 'below' &&
					'-top-1.5 left-1/2 -translate-x-1/2 border-l border-t border-white/10',
			)}
			aria-hidden
		/>
	</div>
);

export { SessionCallProntuarioHintBalloon };
